import React, { Component } from "react";
import { connect } from "react-redux";

import {
  Button,
  message,
  Steps,
  Popconfirm,
  Tag,
  Divider,
  Card,
  Radio,
} from "antd";

import storageUtils from "../../utils/storageUtils";
import { req_single_ams_alumni, req_add_gqm_alumniApplyCard } from "../../api";
import PictureFace from "./picture-face";

const { Step } = Steps;
class AlumniCardApply extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  state = {
    loading: false,
    workstatus: false,
    current: 0,
    steps: [
      {
        title: "申請說明",
        description: "學思卡用途、申請及領取說明",
      },
      {
        title: "基本資料",
        description: "姓名、生活狀況、個資聲明等資料填寫",
      },
      {
        title: "連絡方式",
        description: "電話、電子郵件及地址等資料填寫",
      },
      {
        title: "現況說明",
        description: "若就業或升學，填寫相關資訊",
      },
      {
        title: "在校資訊",
        description: "填寫原本在校學歷資訊驗證",
      },
    ],
    options: [
      {
        label: "掛號寄出(NT$128元)",
        value: "MAIL",
      },
      {
        label: "親取匯款(NT$100元)",
        value: "SELF",
      },
      {
        label: "親取現繳(NT$100元)",
        value: "PAY",
      },
    ],
    lifestatus: 0,
    agreePrivacy: "YES", //個資聲明
    emailSend: "MAIL",
    item: {},
    apply: {
      ProcessStatus: "WAIT",
      TwId: "",
      Birthday: "",
      Sex: "",
      AlumniName: "",
      NowStatusSource: "",
      NowStatusPrimary: "",
      NowStatusSecondary: "",
      NowStatusPrimarySecondary: "",
      MobilePrincipal: "",
      MobileSpare: "",
      TelephonePrincipal: "",
      TelephoneSpare: "",
      EmailPrincipal: "",
      EmailSpare: "",
      MailingAddress: "",
      ResidentAddress: "",
      LastFinalDegree: "",
      LastFinalUniversity: "台南應用科技大學",
      LastFinalDepartmentName: "",
      LastFinalMajor: "",
      LastFinalYearGrade: "",
      ContinueLearnLocation: "",
      ContinueLearnUniversity: "",
      ContinueLearnDepartmentName: "",
      ContinueLearnDegree: "",
      ContinueLearnDivision: "",
      JobType: "",
      JobCompany: "",
      JobDepartment: "",
      JobTitle: "",
      JobTelephone: "",
      JobAddress: "",
      JobFax: "",
      JobFirstSalary: "0",
      CurrentSalary: "0",
      JobBossName: "",
      JobBossEmail: "",
      AgreePrivacy: "YES", //個資聲明
      AgreeAssociationSetInfo: "NO", //收到學生會
      AgreeLabourDepartSendInfo: "YES", //提供勞動部
      PicUrl: "",
      StudentId: "代為查詢",
      IsEmailSend: "MAIL",
      RemitFiveCode: "",
      CaseStatus: "APPLY",
    },
    finishPage: false,
  };

  constructor(props) {
    super(props);

    this.get_face_image = React.createRef();

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleAgree = this.handleAgree.bind(this);
    this.handleDisagree = this.handleDisagree.bind(this);
  }

  UNSAFE_componentWillMount() {}

  componentDidMount() {
    this.api_single_item();
  }

  // 遠端數據處理 //////////////////////////////////////////////

  api_single_item = async () => {
    const { token, userCode } = this.props.user;

    this.setState({ loading: true });
    const result = await req_single_ams_alumni(userCode, token);
    this.setState({ loading: false });
    const item = result;
    this.setState({ item });
    //console.log(item);
    const apply = this.state.apply;
    apply.TwId = result.TwId;
    apply.Sex = result.Sex;
    apply.AlumniName = result.AlumniName;
    apply.Birthday = result.Birthday;
    apply.NowStatusPrimary = result.NowStatusPrimary;
    apply.NowStatusPrimarySecondary = result.NowStatusPrimarySecondary;
    this.handleLifeStatus(result.NowStatusPrimarySecondary);
    this.setState({ apply });
  };

  api_edit_item = async (item) => {
    // message.success("申請學思卡成功");
    // this.setState({ finishPage: true });
    const result = await req_add_gqm_alumniApplyCard(
      item,
      storageUtils.getUser().token
    );
    if (result.status === "success") {
      // console.log(result)
      message.success("申請學思卡成功");
      this.setState({ finishPage: true });
      // this.api_single_item();
    } else {
      message.error(result.message);
    }
  };

  ///////////////////////////////////////////////////////////

  handleChange(event) {
    const { apply } = this.state;
    //console.log(event)
    Object.keys(apply).forEach((propertyName) => {
      if (event.target.id === "AgreePrivacy" && event.target.value !== null) {
        // Checkbox
        apply.AgreePrivacy = event.target.checked;
      } else {
        if (event.target.id === propertyName && event.target.value !== null) {
          apply[propertyName] = event.target.value.trim();
        }
        if (event.target.id === "NowStatusPrimarySecondary") {
          this.handleLifeStatus(event.target.value.trim());
        }
      }
    });
    this.setState({ apply });
  }

  handleSubmit(event) {
    event.preventDefault();
    const { agreeAssociationSetInfo, current, steps, emailSend } = this.state;
    const row = this.state.apply;
    const errors = [];

    if (current === steps.length - 1) {
      const faceimage = this.get_face_image.current.output_files();
      // console.log(faceimage);
      if (faceimage.length > 0) {
        row.PicUrl = faceimage[0];
      } else {
        errors.push("未上傳照片");
      }

      if (!row.AlumniName.trim()) {
        errors.push("姓名未填");
      }
      if (!row.EmailPrincipal.trim()) {
        errors.push("電子郵件未填");
      }
      if (!row.MobilePrincipal.trim()) {
        errors.push("行動電話未填");
      }
      if (!row.MailingAddress.trim()) {
        errors.push("通訊地址未填");
      }

      if (errors.length === 0) {
        row.IsEmailSend = emailSend;
        row.TelephoneSurveyOperator = storageUtils.getUser().userCode;
        row.NowStatusModifyOperator = storageUtils.getUser().userCode;
        row.NowStatusSource = "自行異動";
        row.NowStatusPrimary = row.NowStatusPrimarySecondary.substr(0, 2);
        row.NowStatusSecondary = row.NowStatusPrimarySecondary.substr(2);
        row.AgreeAssociationSetInfo = agreeAssociationSetInfo;
        row.condition = "SELFOPERATOR";
        //console.log(row);
        this.api_edit_item(row);
      } else {
        let info = errors.join(",");
        message.error(info);
      }
    }
  }

  handleAgree() {
    const row = this.state.item;
    row.AgreePrivacy = true;
    this.setState({ item: row });
  }

  handleDisagree() {
    const row = this.state.item;
    row.AgreePrivacy = false;
    this.setState({ item: row });
  }

  handleLifeStatus = (status) => {
    var lifestatus = 0;
    switch (status) {
      case "就業":
      case "就業就業":
      case "就業在職進修":
      case "就業自行創業":
        lifestatus = 1;
        break;
      case "升學升學":
      case "留學留學":
        lifestatus = 2;
        break;
      default:
        console.log(`Sorry`);
    }
    this.setState({ lifestatus });
  };

  next = () => {
    const { current } = this.state;
    this.setState({ current: current + 1 });
  };

  prev = () => {
    const { current } = this.state;
    this.setState({ current: current - 1 });
  };

  onSwitchChange = (checked) => {
    //console.log(checked);
    if (!checked) {
      this.setState({ agreePrivacy: "NO" });
      //console.log("不同意");
    } else {
      this.setState({ agreePrivacy: "YES" });
      //console.log("同意");
    }
  };

  onChangeOptions = ({ target: { value } }) => {
    console.log("領用方式", value);
    this.setState({ emailSend: value });
  };

  /////////////////////////////
  render() {
    const pngFile = [];
    const pngfileUrlPath = "/api/UploadFile/AddInsideMediaFile";
    const {
      TwId,
      AlumniName,
      NowStatusPrimarySecondary,
      MobilePrincipal,
      //MobileSpare,
      RemitFiveCode,
      // TelephoneSpare,
      EmailPrincipal,
      //EmailSpare,
      MailingAddress,
      // ResidentAddress,
      JobType,
      JobTitle,
      // JobFirstSalary,
      CurrentSalary,
      JobCompany,
      // JobDepartment,
      JobTelephone,
      // JobFax,
      JobAddress,
      JobBossName,
      JobBossEmail,
      LastFinalDegree,
      StudentId,
      LastFinalYearGrade,
      LastFinalDepartmentName,
      ContinueLearnUniversity,
      ContinueLearnDepartmentName,
      ContinueLearnDegree,
      ContinueLearnDivision,
      // ContinueLearnLocation,
      IsEmailSend,
    } = this.state.apply;
    const { current, steps, lifestatus, finishPage, options } = this.state;
    const canGoNext = (() => {
      switch (current) {
        case 0:
          // 申請說明頁沒有必填欄位
          return true;

        case 1:
          // 基本資料：姓名
          return Boolean(AlumniName && AlumniName.trim());

        case 2:
          // 聯絡方式：行動電話、電子郵件、通訊地址
          return Boolean(
            MobilePrincipal &&
              MobilePrincipal.trim() &&
              EmailPrincipal &&
              EmailPrincipal.trim() &&
              MailingAddress &&
              MailingAddress.trim()
          );

        case 3:
          // 現況說明目前沒有 * 必填欄位
          return true;

        default:
          return true;
      }
    })();
    return finishPage ? (
      <div style={{ textAlign: "center", margin: "5px" }}>
        <card style={{ fontSize: "1.5em", width: "100%" }}>
          親愛的校友 您好：
          <br />
          感謝您申辦校友學思卡：
          <br />
          如您選擇[親取現繳]：
          <br />
          應繳費用：新台幣 100 元(校友學思卡工本費為100元)
          <br />
          請您收到〝通知取件〞信件後，至母校中正大樓1樓出納組繳費，將有專人為您做發卡服務。
          <p></p>
          如您選擇[親取匯款]：
          <br />
          匯款金額：新台幣 100 元(校友學思卡工本費為100元)
          <br />
          請您收到〝通知取件〞信件後，至母校馨如樓102教室領取。
          <br />
          <p></p>
          如您選擇[掛號寄出]：
          <br />
          匯款金額：新台幣 128 元(校友學思卡工本費為100元+郵寄掛號費用28元)
          <br />
          3~5個工作天後，學思卡連同收據用掛號寄出
          <br />
          <br />
          採用匯款方式，以下為母校銀行帳號：
          <br />
          <p></p>
          銀行名稱：彰化銀行延平分行
          <br />
          銀行代號：009
          <br />
          帳號：64195100368510
          <br />
          戶名：台南家專學校財團法人台南應用科技大學
          <br />
          <p></p>
          完成匯款後，請將您的銀行帳號後5碼回信寄到emalum@mail.tut.edu.tw，俾後續對帳核及製卡
          <br />
        </card>
      </div>
    ) : (
      <form onSubmit={this.handleSubmit}>
        <>
          <div
            style={{
              backgroundColor: "#FDF9F8",
              border: "1px solid #F3F3F3",
              marginBottom: "1px",
            }}
          >
            <Steps current={current} direction="horizontal" size="small">
              {steps.map((item) => (
                <Step
                  key={item.title}
                  title={item.title}
                  description={item.description}
                />
              ))}
            </Steps>
          </div>
          <div
            className="steps-content"
            style={{ border: "1px solid #F3F3F3" }}
          >
            {current === 0 ? (
              <>
                <Card style={{ width: "100%" }}>
                  <p>
                    申請辦理校友學思卡(此證可永久使用)，即享校內設施優惠：雅棧實習旅館(目前暫停接受訂房)、新鑽實習餐廳、儀坊實習美容院、芳療館、推廣教育非學分班、健身房、圖書館借書、文創中心及本校簽訂特約廠商優惠。(註：各場域實際優惠內容以現場公告為主)
                  </p>
                  <p>
                    當年畢業生即可辦理，申請及補發
                    <br />
                    <Tag color="red">到校領取者，酌收工本費，計NT$100元</Tag>
                    <br />
                    <Tag color="red">
                      掛號寄送者，含工本費加收掛號費NT$28元，計NT$128元，
                    </Tag>
                  </p>
                  <p style={{ color: "blue" }}>
                    轉帳匯款後5碼，請寄信到公共事務暨校友服務組信箱(emalum@mail.tut.edu.tw)通知我們，對帳無誤後，校友學思卡及收據會依您申請領取方式(親領通知或掛號寄出)處理。
                  </p>
                  <p>如有疑問，歡迎於來電洽詢。</p>
                  <p>周一～周五(上午8:00~12:00，下午13:00~17:00)</p>
                  <p>
                    聯絡電話:(06)253-2106#206 楊小姐
                  </p>
                  <p>
                    送出申請表單後，製作工時需7-10個工作天，若無疑問，請按
                    <Tag color="blue">下一頁</Tag>進行申請程序。{" "}
                  </p>
                </Card>
              </>
            ) : (
              ""
            )}
            {current === 1 ? (
              <>
                <div className="form-row">
                  <div className="col-lg-3">
                    <div className="form-group">
                      <label>身分證字號</label>
                      <input
                        type="text"
                        className="form-control text-primary"
                        name="TwId"
                        id="TwId"
                        defaultValue={TwId}
                        disabled={true}
                      />
                    </div>
                  </div>
                  <div className="col-lg-9">
                    <div className="form-group">
                      <label>
                        <span
                          className="text-danger"
                          style={{ fontWeight: "bold", fontSize: "1.2em" }}
                        >
                          *
                        </span>
                        姓名
                      </label>
                      <input
                        type="text"
                        className="form-control text-primary"
                        name="AlumniName"
                        id="AlumniName"
                        aria-describedby="AlumniName"
                        placeholder="請輸入姓名"
                        defaultValue={AlumniName}
                        onChange={this.handleChange}
                      />
                    </div>
                  </div>
                </div>
              </>
            ) : (
              ""
            )}
            {current === 2 ? (
              <>
                <div className="form-row">
                  <div className="col-lg">
                    <div className="form-group">
                      <label>
                        <span
                          className="text-danger"
                          style={{ fontWeight: "bold", fontSize: "1.4em" }}
                        >
                          *
                        </span>
                        行動電話
                      </label>
                      <input
                        type="text"
                        className="form-control text-primary"
                        name="MobilePrincipal"
                        id="MobilePrincipal"
                        placeholder="請輸入您的行動電話"
                        defaultValue={MobilePrincipal}
                        onChange={this.handleChange}
                      />
                    </div>
                  </div>
                  <div className="col-lg">
                    <div className="form-group">
                      <label>
                        {" "}
                        <span
                          className="text-danger"
                          style={{ fontWeight: "bold", fontSize: "1.4em" }}
                        >
                          *
                        </span>
                        電子郵件
                      </label>
                      <input
                        type="email"
                        className="form-control text-primary"
                        name="EmailPrincipal"
                        id="EmailPrincipal"
                        aria-describedby="emailHelp"
                        placeholder="請輸入您常用電子郵件"
                        defaultValue={EmailPrincipal}
                        onChange={this.handleChange}
                      />
                    </div>
                  </div>
                </div>
                <div className="form-row">
                  <div className="col-lg">
                    <div className="form-group">
                      <label>
                        <span
                          className="text-danger"
                          style={{ fontWeight: "bold", fontSize: "1.4em" }}
                        >
                          *
                        </span>
                        通訊地址
                      </label>
                      <input
                        type="text"
                        className="form-control text-primary"
                        name="MailingAddress"
                        id="MailingAddress"
                        placeholder="請輸入您目前通訊地址"
                        defaultValue={MailingAddress}
                        onChange={this.handleChange}
                      />
                    </div>
                  </div>
                </div>
                <div className="form-row">
                  <div className="col-lg">
                    <div className="form-group">
                      <label style={{ color: "red" }}>領取方式</label>
                      <div></div>
                      <Radio.Group
                        options={options}
                        onChange={this.onChangeOptions}
                        defaultValue={IsEmailSend}
                        optionType="button"
                        buttonStyle="solid"
                      />
                    </div>
                    <input
                      type="text"
                      className="form-control text-primary"
                      name="RemitFiveCode"
                      id="RemitFiveCode"
                      placeholder="預計匯款帳號後5碼"
                      defaultValue={RemitFiveCode}
                      onChange={this.handleChange}
                    />
                  </div>
                </div>
              </>
            ) : (
              ""
            )}
            {current === 3 ? (
              <>
                <div className="form-row">
                  <div className="col-lg-12">
                    <div className="form-group">
                      <label>生活狀況</label>
                      <select
                        name="NowStatusPrimarySecondary"
                        id="NowStatusPrimarySecondary"
                        className="custom-select mb-3 text-success"
                        defaultValue={NowStatusPrimarySecondary}
                        onChange={this.handleChange}
                        key={NowStatusPrimarySecondary}
                      >
                        {" "}
                        <option value="就業就業">就業</option>
                        <option value="就業在職進修">就業(在職進修)</option>
                        <option value="就業自行創業">就業(自行創業)</option>
                        <option value="其他待業">待業</option>
                        <option value="服役服役">服役</option>
                        <option value="升學升學">升學</option>
                        <option value="留學留學">留學</option>
                        <option value="其他遊學">遊學</option>
                        <option value="其他家管">家管</option>
                        <option value="其他教育實習">教育實習</option>
                        <option value="其他準備考試">準備考試</option>
                      </select>
                    </div>
                  </div>
                </div>
                {lifestatus === 0 ? (
                  <>
                    {" "}
                    <div className="form-row">
                      <div className="col-lg">
                        <div className="form-group">
                          <span>無就業或進修，請按[下一頁]</span>
                        </div>
                      </div>
                    </div>
                  </>
                ) : lifestatus === 1 ? (
                  <>
                    {" "}
                    <div className="form-row">
                      <div className="col-lg-3">
                        <div className="form-group">
                          <label>主要工作型態</label>
                          <select
                            name="JobType"
                            id="JobType"
                            className="custom-select mb-3 text-success"
                            defaultValue={JobType}
                            onChange={this.handleChange}
                            key={JobType}
                          >
                            {" "}
                            <option value="">請選擇</option>
                            <option value="全職">全職</option>
                            <option value="兼職">兼職</option>
                            <option value="正職">正職</option>
                            <option value="約聘">約聘</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="form-group">
                          <label>工作職稱</label>
                          <input
                            type="text"
                            className="form-control text-primary"
                            name="JobTitle"
                            id="JobTitle"
                            placeholder="負責人/經理/業務...."
                            defaultValue={JobTitle}
                            onChange={this.handleChange}
                          />
                        </div>
                      </div>
                      <div className="col-lg-3">
                        <div className="form-group">
                          <label>月均薪金額</label>
                          <input
                            type="number"
                            className="form-control text-primary"
                            name="CurrentSalary"
                            id="CurrentSalary"
                            placeholder="僅填數字"
                            defaultValue={CurrentSalary}
                            onChange={this.handleChange}
                          />
                        </div>
                      </div>
                    </div>
                    <Divider orientation="left" plain>
                      機構行號資訊
                    </Divider>
                    <div className="form-row">
                      <div className="col-lg-5">
                        <div className="form-group">
                          <label>機構名稱</label>
                          <input
                            type="text"
                            className="form-control text-primary"
                            name="JobCompany"
                            id="JobCompany"
                            placeholder="政府組織/公司企業/店名/工作室 名稱"
                            defaultValue={JobCompany}
                            onChange={this.handleChange}
                          />
                        </div>
                      </div>
                      <div className="col-lg-3">
                        <div className="form-group">
                          <label>聯絡電話</label>
                          <input
                            type="text"
                            className="form-control text-primary"
                            name="JobTelephone"
                            id="JobTelephone"
                            placeholder="政府組織/公司企業/店名/工作室 電話"
                            defaultValue={JobTelephone}
                            onChange={this.handleChange}
                          />
                        </div>
                      </div>
                      <div className="col-lg">
                        <div className="form-group">
                          <label>聯絡地址</label>
                          <input
                            type="text"
                            className="form-control text-primary"
                            name="JobAddress"
                            id="JobAddress"
                            placeholder="政府組織/公司企業/店名/工作室 地址"
                            defaultValue={JobAddress}
                            onChange={this.handleChange}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="col-lg-5">
                        <div className="form-group">
                          <label>負責人(或主管)姓名</label>
                          <input
                            type="text"
                            className="form-control text-primary"
                            name="JobBossName"
                            id="JobBossName"
                            placeholder="負責人/主管/雇主 姓名"
                            defaultValue={JobBossName}
                            onChange={this.handleChange}
                          />
                        </div>
                      </div>
                      <div className="col-lg">
                        <div className="form-group">
                          <label>負責人(或主管)電子郵件</label>
                          <input
                            type="text"
                            className="form-control text-primary"
                            name="JobBossEmail"
                            id="JobBossEmail"
                            placeholder="負責人/主管/雇主 電子郵件"
                            defaultValue={JobBossEmail}
                            onChange={this.handleChange}
                          />
                        </div>
                      </div>
                    </div>
                  </>
                ) : lifestatus === 2 ? (
                  <>
                    {" "}
                    <div className="form-row">
                      <div className="col-lg-3">
                        <div className="form-group">
                          <label>進修學校學位</label>
                          <select
                            name="ContinueLearnDegree"
                            id="ContinueLearnDegree"
                            className="custom-select mb-3 text-success"
                            defaultValue={ContinueLearnDegree}
                            onChange={this.handleChange}
                            key={ContinueLearnDegree}
                          >
                            {" "}
                            <option value="">請選擇</option>
                            <option value="博士">博士</option>
                            <option value="碩士">碩士</option>
                            <option value="學士">學士</option>
                            <option value="副學士">副學士</option>
                            <option value="專科">專科</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-lg-3">
                        <div className="form-group">
                          <label>進修學校部別</label>
                          <input
                            type="text"
                            className="form-control text-primary"
                            name="ContinueLearnDivision"
                            id="ContinueLearnDivision"
                            placeholder="例：日間部/進修部..."
                            defaultValue={ContinueLearnDivision}
                            onChange={this.handleChange}
                          />
                        </div>
                      </div>
                      <div className="col-lg-3">
                        <div className="form-group">
                          <label>進修學校校名</label>
                          <input
                            type="text"
                            className="form-control text-primary"
                            name="ContinueLearnUniversity"
                            id="ContinueLearnUniversity"
                            placeholder="例：ＯＯＯＯ大學"
                            defaultValue={ContinueLearnUniversity}
                            onChange={this.handleChange}
                          />
                        </div>
                      </div>
                      <div className="col-lg-3">
                        <div className="form-group">
                          <label>進修學校學系</label>
                          <input
                            type="text"
                            className="form-control text-primary"
                            name="ContinueLearnDepartmentName"
                            id="ContinueLearnDepartmentName"
                            placeholder="例：商品設計系/音樂系..."
                            defaultValue={ContinueLearnDepartmentName}
                            onChange={this.handleChange}
                          />
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  <></>
                )}
              </>
            ) : (
              ""
            )}
            {current === 4 ? (
              <>
                {" "}
                <div className="form-row">
                  <div className="col-lg-2">
                    <div className="form-group">
                      <label>畢業學年度</label>
                      <select
                        name="LastFinalYearGrade"
                        id="LastFinalYearGrade"
                        className="custom-select mb-3 text-success"
                        defaultValue={LastFinalYearGrade}
                        onChange={this.handleChange}
                        key={LastFinalYearGrade}
                      >
                        {" "}
                        <option value="000">請選擇</option>
                        <option value="058">058</option>
                        <option value="059">059</option>
                        <option value="060">060</option>
                        <option value="061">061</option>
                        <option value="062">062</option>
                        <option value="063">063</option>
                        <option value="064">064</option>
                        <option value="065">065</option>
                        <option value="066">066</option>
                        <option value="067">067</option>
                        <option value="068">068</option>
                        <option value="069">069</option>
                        <option value="070">070</option>
                        <option value="071">071</option>
                        <option value="072">072</option>
                        <option value="073">073</option>
                        <option value="074">074</option>
                        <option value="075">075</option>
                        <option value="076">076</option>
                        <option value="077">077</option>
                        <option value="078">078</option>
                        <option value="079">079</option>
                        <option value="080">080</option>
                        <option value="081">081</option>
                        <option value="082">082</option>
                        <option value="083">083</option>
                        <option value="084">084</option>
                        <option value="085">085</option>
                        <option value="086">086</option>
                        <option value="087">087</option>
                        <option value="088">088</option>
                        <option value="089">089</option>
                        <option value="090">090</option>
                        <option value="091">091</option>
                        <option value="092">092</option>
                        <option value="093">093</option>
                        <option value="094">094</option>
                        <option value="095">095</option>
                        <option value="096">096</option>
                        <option value="097">097</option>
                        <option value="098">098</option>
                        <option value="099">099</option>
                        <option value="100">100</option>
                        <option value="101">101</option>
                        <option value="102">102</option>
                        <option value="103">103</option>
                        <option value="104">104</option>
                        <option value="105">105</option>
                        <option value="106">106</option>
                        <option value="107">107</option>
                        <option value="108">108</option>
                        <option value="109">109</option>
                        <option value="110">110</option>
                        <option value="111">111</option>
                        <option value="112">112</option>
                        <option value="113">113</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-lg-2">
                    <div className="form-group">
                      <label>在校學位</label>
                      <select
                        name="LastFinalDegree"
                        id="LastFinalDegree"
                        className="custom-select mb-3 text-success"
                        defaultValue={LastFinalDegree}
                        onChange={this.handleChange}
                        key={LastFinalDegree}
                      >
                        {" "}
                        <option value="">請選擇</option>
                        <option value="博士">博士</option>
                        <option value="碩士">碩士</option>
                        <option value="學士">學士</option>
                        <option value="副學士">副學士</option>
                        <option value="專科">專科</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="form-group">
                      <label>在校系科</label>
                      <input
                        type="text"
                        className="form-control text-primary"
                        name="LastFinalDepartmentName"
                        id="LastFinalDepartmentName"
                        placeholder="例：商品設計系/音樂科..."
                        defaultValue={LastFinalDepartmentName}
                        onChange={this.handleChange}
                      />
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="form-group">
                      <label>在校學號</label>
                      <input
                        type="text"
                        className="form-control text-primary"
                        name="StudentId"
                        id="StudentId"
                        placeholder="不確定時請填寫-代為查詢"
                        defaultValue={StudentId}
                        onChange={this.handleChange}
                      />
                    </div>
                  </div>
                </div>
                <div className="form-row">
                  <div className="col-lg-12">
                    <div className="form-group">
                      <label>
                        <span
                          className="text-danger"
                          style={{ fontWeight: "bold", fontSize: "1.2em" }}
                        >
                          *
                        </span>
                        大頭照【Pic】(請上傳學士照或一般大頭照)
                      </label>
                      <PictureFace
                        ref={this.get_face_image}
                        data_source={pngFile}
                        api_url={pngfileUrlPath}
                      ></PictureFace>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              ""
            )}
          </div>
          <div className="steps-action" style={{ marginTop: "4px" }}>
            {current < steps.length - 1 && (
              <button
                type="button"
                className="btn btn-primary btn-sm"
                onClick={this.next}
                disabled={!canGoNext}
              >
                下一頁
              </button>
            )}
            {current === steps.length - 1 && (
              <>
                <Popconfirm
                  title="因應個人資料保護法及本校個人資料管理規定，本校在向您蒐集個人資料之前，依法向您告知下列事項，當您勾選「我同意」，表示您已閱讀、瞭解並同意接受本同意書之所有內容：
                                    一、蒐集目的及類別
                                    為提供活動各項通知服務、報名資料確認、寄送本校或產業相關活動訊息及本校內部管理使用之蒐集目的，而須獲取您下列個人資料類別： 姓名、電話、E-mail 或其他得以直接或間接識別您個人之資料。
                                    二、個人資料利用之期間、地區、對象及方式
                                    您的個人資料，除涉及國際業務或活動外，僅供本校及活動協辦單位於中華民國領域，於上述蒐集目的之必要合理範圍內加以利用至前述蒐集目的消失時為止。
                                    
                                    三、當事人權利行使
                                    依據個人資料保護法第3條規定，您可向本校請求查詢或閱覽、製給複製本、補充或更正、停止蒐集/處理/利用或刪除您的個人資料。
                                    
                                    四、不提供個人資料之權益影響
                                    如您不提供或未提供正確之個人資料，或要求停止蒐集/處理/利用/刪除個人資料、服務訊息的取消訂閱，本校將無法為您提供蒐集目的之相關服務。
                                    
                                    五、各項通知服務、相關訊息之停止寄送，或違反本個資聲明之行為。您可於上班時間聯繫承辦人（電話06-2535642，分機 227、229）反映。
                                     
                                    個人資料同意提供：
                                    一、本人確已閱讀並瞭解上述告知事項，並勾選「我同意」授權貴校於所列目的之必要合理範圍內，蒐集、處理及利用本人之個人資料。
                                    二、本人瞭解此同意書符合個人資料保護法及相關法規之要求，並提供予貴校留存及日後查證使用。"
                  cancelText="了解"
                >
                  <Button type="link">
                    註：送出即同意[蒐集個資告知事項暨個人資料]宣告
                  </Button>
                </Popconfirm>
                <button type="submit" className="btn btn-success btn-sm">
                  送出
                </button>
              </>
            )}
            {current > 0 && (
              <button
                className="btn btn-light btn-sm"
                style={{
                  margin: "0 8px",
                }}
                onClick={this.prev}
              >
                上一頁
              </button>
            )}
          </div>
        </>
      </form>
    );
  }
}

export default connect((state) => ({ user: state.user }), {})(AlumniCardApply);
